import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import { param } from 'jquery';
const albumApi = {
  UploadTempPhoto(params) {
    return axios.post(`${base.dev}/TokenAuth/UploadTempPhoto`, params);
  },
  getUserTempleList(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/getUserTempleList`,
      params
    );
  },
  //人脸识别
  UploadFaceSearchPhoto(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/UploadFaceSearchPhoto`,
      params
    );
  },
  //前台
  GetalbumHotWeek(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetAll`,
      params
    );
  },
  GetPhotoGalleryList(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetPhotoGalleryList`,
      params
    );
  },
  GetPhotoGalleryListNew(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetPhotoGalleryListNew`,
      params
    );
  },
  GetBaiErrorPhoto(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetBaiErrorPhoto`,
      { params }
    );
  },
  GetPhotoDtl(params) {
    return axios.get(`${base.dev}/services/app/PhotoGalleryList/GetPhotoDtl`, {
      params
    });
  },
  getAlbumDtl(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetDtl`,
      { params }
    );
  },
  delAlbuma(params) {
    return axios.delete(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/Delete`,
      { params: params }
    );
  },
  delphoto(params) {
    return axios.delete(`${base.dev}/services/app/PhotoGalleryList/Delete`, {
      params: params
    });
  },
  delphotoPage(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryList/DeletePage`,
      params
    );
  },
  delphotoAll(params) {
    return axios.delete(`${base.dev}/services/app/PhotoGalleryList/DeleteAll`, {
      params: params
    });
  },
  updateAlbum(params) {
    return axios.put(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/Update`,
      params
    );
  },

  //后台
  PushRetryDto(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPhotoGalleryConfigAppSerivce/PushRetryDto`,
      { params }
    );
  },
  GetAdminPhotoGalleryList(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPhotoGalleryConfigAppSerivce/GetAll`,
      params
    );
  },
  AdminPhotoGalleryConfigAppSerivceGetExecuting(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPhotoGalleryConfigAppSerivce/GetExecuting`,
      { params }
    );
  },
  //UpdateExecutingStatus 人臉識別重新加載
  UpdateExecutingStatus(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPhotoGalleryConfigAppSerivce/UpdateExecutingStatus`,
      { params }
    );
  },

  //#region 用户主页
  //獲取用戶發佈的相簿
  getPicturePublish(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetAllByUser`,
      { params }
    );
  },
  //獲取指定用戶發佈的相簿
  getPicturePublishLook(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetAll`,
      params
    );
  },
  //收藏
  getFavoriteByUserId(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/getFavoriteByUserId`,
      { params }
    );
  },
  getFavoritePicture(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryList/getFavoriteByUserId`,
      { params }
    );
  },
  delAlbum(params) {
    return axios.delete(
      `${base.dev}/services/app/AdminPhotoGalleryConfigAppSerivce/Delete`,
      { params: params }
    );
  },

  UploadImage(params) {
    var forms = new FormData();
    var configs = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    };
    forms.append("data", params.data);
    forms.append("Type", params.Type);
    forms.append("id", params.id);
    return axios.post(
      `${base.dev}/TokenAuth/MinioUpload/Upload/MinioUpload`,
      forms
    );
  },
  createAlbum(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/Create`,
      params
    );
  },

  uploadImages(url, params) {
    return axios.post(url, params);
  },

  getMessageByTypeId(params) {
    return axios.get(`${base.dev}/services/app/Message/GetAllByTypeId`, {
      params
    });
  },
  createMessage(params) {
    return axios.post(`${base.dev}/services/app/Message/Create`, params);
  },

  AdminPhotoCollectionGet(params) {
    return axios.get(
      `${base.dev}/services/app/AdminPhotoCollectionAppSerivce/Get`,
      { params }
    );
  },

  AdminPhotoCollectionGetAll(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPhotoCollectionAppSerivce/GetAll`,
      params
    );
  },

  AdminPhotoCollectionCreate(params) {
    return axios.post(
      `${base.dev}/services/app/AdminPhotoCollectionAppSerivce/Create`,
      params
    );
  },
  AdminPhotoCollectionUpdate(params) {
    return axios.put(
      `${base.dev}/services/app/AdminPhotoCollectionAppSerivce/Update`,
      params
    );
  },
  AdminPhotoCollectionDelete(params) {
    return axios.delete(
      `${base.dev}/services/app/AdminPhotoCollectionAppSerivce/Delete`,
      { params: params }
    );
  },
  AdminPhotoCollectionUpdateTop(params) {
    return axios.put(
      `${base.dev}/services/app/AdminPhotoCollectionAppSerivce/UpdateTop`,
      params
    );
  },

  PhotoCollectionGetAll(params) {
    return axios.post(
      `${base.dev}/services/app/PhotoCollectionAppSerivce/GetAll`,
      params
    );
  },
  GetVRanking(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/GetVRanking`,
      { params }
    );
  },
  PhotoCollectionGetDtl(params) {
    return axios.get(
      `${base.dev}/services/app/PhotoCollectionAppSerivce/GetDtl`,
      { params }
    );
  }

  //#endregion
};
export default albumApi


// WEBPACK FOOTER //
// ./src/api/album/albumApi.js